import { useEffect, useState } from 'react';

function Sprite({ src, fallback, alt, className }) {
  const [current, setCurrent] = useState(src || fallback || '');

  useEffect(() => {
    setCurrent(src || fallback || '');
  }, [src, fallback]);

  if (!current) return null;

  return (
    <img
      className={className}
      src={current}
      alt={alt}
      onError={() => {
        if (fallback && current !== fallback) setCurrent(fallback);
      }}
    />
  );
}

export default Sprite;
